import { render, staticRenderFns } from "./materialpay.vue?vue&type=template&id=f5bab41e&scoped=true&"
import script from "./materialpay.vue?vue&type=script&lang=js&"
export * from "./materialpay.vue?vue&type=script&lang=js&"
import style0 from "./materialpay.vue?vue&type=style&index=0&id=f5bab41e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5bab41e",
  null
  
)

export default component.exports